// extracted by mini-css-extract-plugin
module.exports = {"entityRoles":"ob_bTJLSh","entityRoles__roles":"ob_tdnUvx"};